import gql from 'graphql-tag';

export const CANCEL_AGREEMENT_MUTATION = gql`
  mutation CancelAgreement($agreementId: Float!) {
    result: cancelAgreement(agreementId: $agreementId)
  }
`;
